module.exports = "/_next/static/images/ribbon-line-97e4ed2b3b4550234e4535ebc357a364.svg";